import { FieldFile } from "components/GeneralFormView/FormField/types";

// DtO/sportsDTO.ts
export interface SportDTO {
  id?: number;
  name: string;
  nameShort: string;
}


// DtO/sportsDTO.ts
export interface SportToSave {
  id?: number;
  name: string;
  nameShort: string;
}

// DTO/tournamentDTO.ts
export interface TournamentDTO {
  id?: number;
  name: string;
  nameShort: string;
  logo?: string;
  sport: SportDTO;
  gender: GenderDto;
}

export interface TournamentToSave {
  id?: number;
  name: string;
  nameShort: string;
  logo?: string | FieldFile;
  sportId: number;
  genderId: number;
}



// DTO/MatchDTO.ts

export interface TeamDTO {
  id: number;
  name: string;
  nameShort: string;
  logo: string | null;
  tournaments: TournamentDTO[];
}

export interface TeamToSAVE {
  id?: number;
  name: string;
  nameShort: string;
  logo?: string | FieldFile;
  tournamentIds: number[];
}



export interface EventDTO {
  id: number;
  description: string | null;
  eventAt: Date;
  type: liveScoringEventType; // Consider creating an enum for event types
  matchId: number;
  teamId?: number | null;
}

export interface EventToSave {
  id?: number;
  description: string | null;
  eventAt: Date;
  type: liveScoringEventType; // Consider creating an enum for event types
  matchId?: number;
  teamId?: number | null;
}

export interface CreateEventPayload {
  event: EventToSave,
  notification: { title: string, body: string; }
}


export interface MatchDTO {
  id: number;
  teamHId: number;
  teamAId: number;
  start_date: string;
  genderId: number;
  tormentId: number;
  teamH: TeamDTO;
  teamA: TeamDTO;
  tournament: TournamentDTO;
  gender: GenderDto;
  events: EventDTO[];
  stadium: string;
}

export interface MatchToSave {
  id?: number;
  teamHId: number;
  teamAId: number;
  start_date: string;
  genderId: number;
  tournamentId: number;
  stadium: string;
}

// Data Transfer Object that matches API payloads

export interface GenderDto {
  id: number;
  title: string;
}

export interface GenderToSave {
  id: number;
  title: string;
}



// ---------------- GENERAL EVENTS ----------------
export enum GeneralEvent {
  MATCH_SCHEDULED = "MATCH_SCHEDULED",
  MATCH_START = "MATCH_START",
  MATCH_SUSPENDED = "MATCH_SUSPENDED",
  MATCH_RESUMED = "MATCH_RESUMED",
  MATCH_END = "MATCH_END",
}

// ---------------- FOOTBALL EVENTS ----------------
export enum FootballEvent {
  MATCH_START = "MATCH_START",
  HALF_TIME_START = "HALF_TIME_START",
  HALF_TIME_END = "HALF_TIME_END",
  EXTRA_TIME_START = "EXTRA_TIME_START",
  EXTRA_TIME_HALF_TIME = "EXTRA_TIME_HALF_TIME",
  EXTRA_TIME_SECOND_HALF_START = "EXTRA_TIME_SECOND_HALF_START",
  EXTRA_TIME_END = "EXTRA_TIME_END",
  PENALTY_SHOOTOUT_START = "PENALTY_SHOOTOUT_START",
  PENALTY_MISS = "PENALTY_MISS",
  YELLOW_CARD = "YELLOW_CARD",
  RED_CARD = "RED_CARD",
  MATCH_SUSPENDED = "MATCH_SUSPENDED",
  MATCH_RESUMED = "MATCH_RESUMED",
  MATCH_END = "MATCH_END",
  SCORE_GOAL = "SCORE_GOAL",
}

// ---------------- HANDBALL EVENTS ----------------
export enum HandballEvent {
  MATCH_START = "MATCH_START",
  HALF_TIME_START = "HALF_TIME_START",
  HALF_TIME_END = "HALF_TIME_END",
  EXTRA_TIME_START = "EXTRA_TIME_START",
  EXTRA_TIME_HALF_TIME = "EXTRA_TIME_HALF_TIME",
  EXTRA_TIME_SECOND_HALF_START = "EXTRA_TIME_SECOND_HALF_START",
  EXTRA_TIME_END = "EXTRA_TIME_END",
  TIMEOUT = "TIMEOUT",
  SUSPENSION_2_MIN = "SUSPENSION_2_MIN",
  PLAYER_RETURN = "PLAYER_RETURN",
  YELLOW_CARD = "YELLOW_CARD",
  RED_CARD = "RED_CARD",
  MATCH_SUSPENDED = "MATCH_SUSPENDED",
  MATCH_RESUMED = "MATCH_RESUMED",
  MATCH_END = "MATCH_END",
  SCORE_GOAL = "SCORE_GOAL",
}

// ---------------- BASKETBALL EVENTS ----------------
export enum BasketballEvent {
  QUARTER_START = "QUARTER_START",
  QUARTER_END = "QUARTER_END",
  EXTRA_TIME_START = "EXTRA_TIME_START",
  TIMEOUT = "TIMEOUT",
  FOUL = "FOUL",
  MATCH_SUSPENDED = "MATCH_SUSPENDED",
  MATCH_RESUMED = "MATCH_RESUMED",
  MATCH_END = "MATCH_END",
  SCORE_GOAL = "SCORE_GOAL",
  SCORE_GOAL_2 = "SCORE_GOAL_2",
  SCORE_GOAL_3 = "SCORE_GOAL_3",
}

// ---------------- VOLLEYBALL EVENTS ----------------
export enum VolleyballEvent {
  SET_START = "SET_START",
  SET_END = "SET_END",
  TIMEOUT = "TIMEOUT",
  SUBSTITUTION = "SUBSTITUTION",
  MATCH_SUSPENDED = "MATCH_SUSPENDED",
  MATCH_RESUMED = "MATCH_RESUMED",
  MATCH_END = "MATCH_END",
  SCORE_GOAL = "SCORE_GOAL",
}


export enum SportNameShort {
  foot = "foot",
  hand = "hand",
  voll = "voll",
  bask = "bask"
}
export type liveScoringEventType = VolleyballEvent | BasketballEvent | HandballEvent | FootballEvent | GeneralEvent;


export const eventsSportMap = {
  [SportNameShort.foot]: GeneralEvent && FootballEvent,
  [SportNameShort.hand]: GeneralEvent && HandballEvent,
  [SportNameShort.bask]: GeneralEvent && BasketballEvent,
  [SportNameShort.voll]: GeneralEvent && VolleyballEvent,

}


export const TEAM_SPECIFIC_EVENTS = [
  FootballEvent.PENALTY_MISS,

  HandballEvent.YELLOW_CARD,
  HandballEvent.RED_CARD,
  HandballEvent.SUSPENSION_2_MIN,

  // Basketball
  BasketballEvent.SCORE_GOAL,
  BasketballEvent.SCORE_GOAL_2,
  BasketballEvent.SCORE_GOAL_3,
  BasketballEvent.FOUL,

  // Volleyball
  VolleyballEvent.SCORE_GOAL,
  VolleyballEvent.SUBSTITUTION,
] as const;
